import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { InstrumentType, SavingsPlan } from '@zero/shared/util-models';

@Directive({})
export class SavingPlanItemBase {
  @Input() public set item(value: SavingsPlan) {
    this.isCrypto = value.instrumentType === InstrumentType.Crypto;
    this._item = value;
  }

  public get item(): SavingsPlan {
    return this._item;
  }

  @Output() public editPlan = new EventEmitter<SavingsPlan>();
  @Output() public cancelPlan = new EventEmitter<SavingsPlan>();

  public isCrypto = false;

  private _item: SavingsPlan;

  public onEdit() {
    this.editPlan.emit(this.item);
  }

  public onCancel() {
    this.cancelPlan.emit(this.item);
  }
}
